module.exports = __webpack_public_path__ + "media/images/lb/603-2e62b14f5ea240b2c92c919a9e79fca2.svg";